import styled from 'styled-components';

export const ToolboxContainer = styled.div`
  display: flex;
  width: fit-content;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.4);
  border-top: 3px solid ${({ theme }: {theme: any}) => theme.themePrimary};
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  border-radius: 6px;
  z-index: 10000;

  animation-duration: 0.5s;
  animation-name: show;
  animation-fill-mode: both;

  @keyframes show {
    0% {
      transform: translateY(10px);
      opacity: 0.2;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const AiTrigger = styled.div`
  position: relative;
  height: 2.5rem;
  display: flex;
  border-radius: 6px;
  align-items: center;
  gap: 0.5rem;
  padding: 0px 1rem;
  color: ${({ theme }: {theme: any}) => theme.neutralTertiary};
  /* color: ${({ theme }: {theme: any}) => theme.themePrimary}; */
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${({ theme }: {theme: any}) => theme.neutralLight};

  span {
    color: inherit;
    font-weight: 600;
  }

  svg {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
  }

  .tag {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;
    padding: 2px 6px;
    border-radius: 5px;
    font: 400 12px/12px 'Roboto', sans-serif;
  }

  &:hover {
    /* background: ${({ theme }: {theme: any}) => theme.themePrimary}; */
    /* color: #fff; */
  }
`;
